import React, { useEffect, useState } from 'react';
import { Container, Logo, LogoWrapper } from './BotWithAnumatedBorder.styles';
const BotWithAnimatedBorder = ({
  isMuted,
  mediaStreamRef
}) => {
  const [isSpeaking, setIsSpeaking] = useState(false);
  const [, setAudioContext] = useState(null);
  const [, setAnalyser] = useState(null);
  const stream = mediaStreamRef.current;
  useEffect(() => {
    if (stream) {
      const audioCtx = new window.AudioContext();
      const analyserNode = audioCtx.createAnalyser();
      const source = audioCtx.createMediaStreamSource(stream);
      source.connect(analyserNode);
      analyserNode.fftSize = 256;
      const bufferLength = analyserNode.frequencyBinCount;
      const dataArray = new Uint8Array(bufferLength);
      setAudioContext(audioCtx);
      setAnalyser(analyserNode);
      const detectSpeech = () => {
        analyserNode.getByteFrequencyData(dataArray);
        const avgVolume = dataArray.reduce((a, b) => a + b) / bufferLength;
        if (avgVolume > 10) {
          setIsSpeaking(true);
        } else {
          setIsSpeaking(false);
        }
      };
      const intervalId = setInterval(detectSpeech, 100);
      return () => {
        clearInterval(intervalId);
      };
    }
  }, [stream]);
  return React.createElement(Container, null, React.createElement(LogoWrapper, {
    isSpeaking: isSpeaking && !isMuted
  }, React.createElement(Logo, {
    src: 'https://s1.pclncdn.com/design-assets/pcln-bot/logos/pcln_bot_opener_logo_no_border_v1.1.svg',
    alt: 'Priceline Bot Logo'
  })));
};
export default BotWithAnimatedBorder;